import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../context/ThemeContext';
import { getLogoVariant } from '../../utils/logoAssets';
import { getAssetPath } from '../../utils/publicPath';

const BRAND_NAME = 'Mutawir Studios';

const Logo = ({ limage, dimage, simage, className }) => {
  const { i18n } = useTranslation();
  const { theme } = useTheme();

  const normalizedTheme = theme === 'light' ? 'light' : 'dark';
  const lang = (i18n && i18n.language) ? i18n.language : undefined;
  const variant = getLogoVariant(lang) || {};

  const lightLogo = limage || variant.light;
  const darkLogo = dimage || variant.dark;
  const stickyLogo = simage || (normalizedTheme === 'light' ? lightLogo : darkLogo);

  return (
    <Link to="/" className={className} aria-label={BRAND_NAME}>
      <img
        className="light-version-logo"
        src={getAssetPath(lightLogo)}
        alt={`${BRAND_NAME} light logo`}
      />
      <img
        className="dark-version-logo"
        src={getAssetPath(darkLogo)}
        alt={`${BRAND_NAME} dark logo`}
      />
      <img
        className="sticky-logo"
        src={getAssetPath(stickyLogo)}
        alt={`${BRAND_NAME} sticky logo`}
      />
    </Link>
  );
};

export default Logo;
